module.exports = __webpack_public_path__ + "static/media/my.c52af28e.svg";